/**
 * @generated SignedSource<<d937738910b50b1030ae4d4e02ceabed>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useLabelFeedPostsQuery$variables = {
  cloudId?: string | null;
  cqlQuery: string;
  isEnabled: boolean;
};
export type useLabelFeedPostsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useLabelFeedPostsQuery_fragment">;
};
export type useLabelFeedPostsQuery = {
  response: useLabelFeedPostsQuery$data;
  variables: useLabelFeedPostsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cqlQuery"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEnabled"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "cql",
    "variableName": "cqlQuery"
  },
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useLabelFeedPostsQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "cqlQuery",
                "variableName": "cqlQuery"
              },
              (v2/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "useLabelFeedPostsQuery_fragment"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLabelFeedPostsQuery",
    "selections": [
      {
        "condition": "isEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConfluenceSearchResponseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ]
          },
          {
            "args": (v3/*: any*/),
            "filters": [
              "cloudId",
              "cql"
            ],
            "handle": "connection",
            "key": "useLabelFeedPostsQuery__confluence_search",
            "kind": "LinkedHandle",
            "name": "confluence_search"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ab210b868db3b37d68aa23f810ec714d",
    "id": null,
    "metadata": {},
    "name": "useLabelFeedPostsQuery",
    "operationKind": "query",
    "text": "query useLabelFeedPostsQuery(\n  $cloudId: ID\n  $cqlQuery: String!\n  $isEnabled: Boolean!\n) {\n  ...useLabelFeedPostsQuery_fragment_kFztA @include(if: $isEnabled)\n}\n\nfragment useLabelFeedPostsQuery_fragment_kFztA on Query {\n  confluence_search(cloudId: $cloudId, cql: $cqlQuery, first: 10) {\n    edges {\n      node {\n        content {\n          id\n          type\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b210fcae77ce3990979fffe39f7ca82c";

export default node;
